export const ErrorCategories = {
    API_ERROR :"API_ERROR",
    OTHER :"OTHER_ERROR",
    UNCAUGHT_ERROR : "UNCAUGHT_ERROR",
    ERROR_BOUNDARY :"ERROR_BOUNDARY"
}